const initialState = [];

const ExchangeRateArray = (state = initialState, action) => {
  switch (action.type) {
    case "setexchangeRateArray":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ExchangeRateArray;
